export default __webpack_public_path__ + "static/media/ygg_logo.3183f06b.png";